import React from 'react';
import Carousel from '../Carousel/carousel';
import Dots from '../Carousel/indicator-dots';
import ImageViewer from '../../../../native/ImageViewer';
import MediaViewer from '../../../../native/MediaViewer';
import {Webp} from '../../formateImage';
import { supportNative } from '../../../../native/util';
import Detector from '../../../../utils/detector';
import { sendStatsEvent } from '../../../statistics';


let checkSupportPageLink = false;
let version = Detector.browser.fullVersion.split('.');
const zuzucheVer = (version[0] >= 5 && version[1] >= 3 && version[2] >= 6);
const tantuVer = (version[0] >= 1 && version[1] >= 5);
if((Detector.browser.zuzuche && zuzucheVer) || (Detector.browser.tantutravel && tantuVer)){
  checkSupportPageLink = true;
}

export default class HeaerBanner extends React.Component{
  constructor(props){
    super(props);
    this.AppPhotos = props.attachInfo.album_list.map((item)=>{
      return { 
        url: item.pic_url,
        description:  ''
      };
    });
  }

  render(){
    let { attachInfo, tabType, pic } = this.props;
    let imageList = this.getVideoImageList();
    if(tabType !== 'introduction' ) return null;
    if(!imageList.length || imageList.length === 1){
      let formateImage = `${(imageList[0] && imageList[0].pic_url) || pic.base}!/fw/750`;
      formateImage = Webp(formateImage);
      return(
        <div className="banner">
          <div className="banner-entity" 
            onClick={()=>{
              this.showBigOneImage(formateImage); 
            }}
            style={{backgroundImage: `url(${formateImage})`}}>
          </div>
        </div>
      );
    }
    return(
      <div className="banner">
        <Carousel loop auto axis="x" widgets={[Dots]}>
          {
            imageList.map((item,index)=>{
              let formateImage = `${item.pic_url}!/fw/690`;
              formateImage = item.isVideo ? item.pic_url : Webp(formateImage);
              return (
                <div key={`${item.poi_id}${index}`} 
                  onClick={()=>{
                    this.showNativeViewer(index);
                  }}
                  className="banner-entity" 
                  style={{backgroundImage: `url(${formateImage})`}}>
                  {item.isVideo ? 
                    <div className="video-tag"><i className="icon icon-video-play"></i></div>
                    : null
                  }
                </div>
              );
            })
          }
        </Carousel>
        {imageList.length > 1 ?
          <div className="image-total">
            /{this.props.bannerVideo && supportNative('base_mediaViewer') && checkSupportPageLink ? attachInfo.album_count + 1 : attachInfo.album_count}
          </div> : null }
      </div>
    );
  }
  
  getVideoImageList(picCount){
    let { attachInfo, bannerVideo} = this.props;
    let videoImageList = [];
    if(bannerVideo && supportNative('base_mediaViewer') && checkSupportPageLink){
      videoImageList.push({
        isVideo: true,
        pic_url: bannerVideo.customCoverImg,
      });
    }
    let imageList = attachInfo.album_list.filter((item,index)=>{
      return index < 5;
    }) || [];

    videoImageList = videoImageList.concat(imageList);
    return videoImageList;
  }

  /**
   * 显示一张图
   */
  showBigOneImage = (pic)=>{
    ImageViewer({
      title: '',
      photos: [{ 
        url: pic,
        description:  ''
      }],
      showIndex:  1,
      success: function (response) {
        console.log(response);
      }
    });
  }


  showNativeViewer = (index) =>{
    if(checkSupportPageLink && supportNative('base_mediaViewer')){
      if(index === 0){
        sendStatsEvent('poi_poivideoclick');
      }else{
        sendStatsEvent('poi_poiphoto_click');
      }
      this.showMediaViewer(index);
    }else{
      sendStatsEvent('poi_poiphoto_click');
      this.showImageViewer(index + 1);
    }
  }

  //1.5以下版本使用原生全屏显示图片
  showImageViewer = (index)=>{
    let { AppPhotos } = this;
    console.log(AppPhotos);
    ImageViewer({
      title: '',
      photos: AppPhotos,
      showIndex: index,
      success: function (response) {
        console.log(response);
      }
    });
  }

  //1.5及以上版本使用混合视频图片播放
  showMediaViewer = (index, pic_list)=>{
    let media = this.mediaList || this.getMeidaList();
    console.log(media);
    MediaViewer({
      title: '',
      media: media,
      showIndex: index,
      success: function (response) {
        console.log(response);
      }
    });
  }


  getMeidaList(){
    let { attachInfo, bannerVideo} = this.props;
    this.mediaList = [];
    if(bannerVideo){
      this.mediaList.push({
        type: 'video',
        media_info: {
          id: '', // 视频ID
          desc: '', // 视频描述
          url: bannerVideo.videoUrl, // 视频播放地址
          cover_img: bannerVideo.customCoverImg, // 封面图地址
        }
      });
    }
    let imageList = attachInfo.album_list.map((item,index)=>{
      return {
        type: 'image',
        media_info:{
          desc: '', // 图片描述
          cover_img: item.pic_url, // 图片地址
        }
      };
    }) || [];

    this.mediaList = this.mediaList.concat(imageList);
    return this.mediaList;
  }

}



// WEBPACK FOOTER //
// ./src/components/Poi2/Introduction/HeaderBanner/index.js